import { render, staticRenderFns } from "./invalid.vue?vue&type=template&id=55143599"
import script from "./invalid.vue?vue&type=script&lang=js"
export * from "./invalid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports